import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Image from '../../base_image/component';
import Link from '../../base_link/component';
import { getTextColor } from '@utils';
import './styles/styles.scss';

class BannerRibbon extends Component {
  constructor(props) {
    super(props);

    this.pushGoogleTags = this.pushGoogleTags.bind(this);
  }

  pushGoogleTags() {
    this.props.googleTagMethods()
      .pushPromotionGoogleTag(this.props);
  }

  bannerContent() {
    const { title, subtitle, buttonText, leftImage, url } = this.props;
    return (
      <Fragment>
        <div className="col-md-2 hidden-xs hidden-sm image-left">
          <div className="img-container">
            <Image src={leftImage} alt={title} />
          </div>
        </div>
        <div className="col-md-8 banner-content">
          <span>{title}</span>
          { subtitle &&
            <span className="subtitle">{subtitle}</span>
          }
        </div>
        <div className="col-sm-2 banner-button">
          {buttonText && (
            <Link href={url} >{buttonText}</Link>
          )}
        </div>
      </Fragment>
    );
  }

  render() {
    const { url, colorCode, backgroundImage, title } = this.props;
    const backgroundStyle = { backgroundColor: colorCode };
    if (!!url) {
      return (
        <Link href={url} style={backgroundStyle} className={`banner ribbon-banner clearfix ${getTextColor(colorCode)}`}>
          <div className="img-container">
            <Image src={backgroundImage} alt={title} />
          </div>
          {this.bannerContent()}
        </Link>
      );
    }
    return (
      <div style={backgroundStyle} className={`banner ribbon-banner clearfix ${getTextColor(colorCode)}`}>
        <div className="img-container">
          <Image src={backgroundImage} alt={title} />
        </div>
        {this.bannerContent()}
      </div>
    );
  }
}

BannerRibbon.propTypes = {
  /**
   * The title which will be shown in black in the banner
   */
  title: PropTypes.string,
  /**
   * The subtitle which will be shown underneith the title
   * The subtitle wil not be displayed on small (mobile) devices
   */
  subtitle: PropTypes.string,
  /**
   * The url the banner needs to point to
   */
  url: PropTypes.string,
  /**
   * Color code for the background
   */
  colorCode: PropTypes.string,
  /**
   * Image placed in the background
   */
  backgroundImage: PropTypes.string,
  /**
   * Image place on the left side of the banner
   * Th left image wil not be displayed on small (mobile) devices
   */
  leftImage: PropTypes.string,
  /**
   * Text that is placed inside the button
   * if there is no text, there will be no button shown
   */
  buttonText: PropTypes.string,

  googleTagMethods: PropTypes.func,
};


export default BannerRibbon;
